import React from 'react';

import ToolTipComponent from './toolTipComponent';

import dropdownArrowBlack from '../../../assets/svg/dropdown-arrow-black.svg';

import './autocompleteDropdownComponent.css';

const AutocompleteDropdownComponentRender = ({
  displayLabel = false,
  enableAutoComplete = false,
  isDisabled = false,
  isMultiSelect = false,
  title = 'Select from Options',
  selectedItemIds = [],
  labelKey = 'label',
  valueKey = 'value',
  tooltipText = '',
  viewDropdown,
  handleBlur,
  handleKeyDown,
  inputRef,
  inputValue,
  handleChange,
  handleFocus,
  showlabel,
  selectedLabel,
  handleTooltip,
  showTooltipComponent,
  dropDownData,
  handleClick,
  multipleSelectedOptions,
  lastValue,
}) => {
  return (
    <>
      {viewDropdown ? (
        <div
          className="et-autocomplete-dropdown-overlay"
          id="et-autocomplete-dropdown-overlay"
          onClick={handleBlur}
        />
      ) : null}
      <div
        className={`et-autocomplete-dropdown ${isDisabled ? 'et-autocomplete-dropdown-disabled' : ''}`}>
        {enableAutoComplete ? (
          <div className="et-autocomplete-dropdown-input">
            <div style={{flex: 1}}>
              <input
                onKeyDown={handleKeyDown}
                ref={inputRef}
                placeholder={title || 'select an option'}
                value={inputValue}
                type="text"
                onChange={handleChange}
                onFocus={handleFocus}
                readOnly={showlabel}
              />
            </div>
            {isDisabled ? (
              ''
            ) : (
              <>
                {/* <span
                  className="et-autocomplete-dropdown-close"
                  onClick={clearSearch}>
                  <img src={closeIcon} alt="" />
                </span> */}

                <span
                  className="et-autocomplete-dropdown-arrow"
                  onClick={viewDropdown ? handleBlur : handleFocus}>
                  <img src={dropdownArrowBlack} alt="" />
                </span>
              </>
            )}
          </div>
        ) : (
          <div
            onChange={handleChange}
            className="et-autocomplete-dropdown-static-selector">
            <span
              className={`et-autocomplete-dropdown-title ${isDisabled ? 'et-autocomplete-dropdown-title-disabled' : ''}`}
              onClick={handleFocus}>
              {inputValue ? (displayLabel ? selectedLabel : inputValue) : title}
            </span>

            <span
              className={`et-autocomplete-dropdown-arrow ${isDisabled ? 'et-autocomplete-dropdown-arrow-disabled' : ''}`}
              onClick={viewDropdown ? handleBlur : handleFocus}>
              <img src={dropdownArrowBlack} alt="" />
            </span>
          </div>
        )}
        {tooltipText && tooltipText.length ? (
          <div
            className="et-autocomplete-custom-tooltip"
            onMouseEnter={handleTooltip}
            onMouseLeave={handleTooltip}
            onClick={handleTooltip}>
            {showTooltipComponent && (
              <ToolTipComponent
                toolTipTxt={tooltipText.length ? tooltipText : ''}
                toolTipPosition="top-left"
              />
            )}
            <i className="far fa-question-circle" />
          </div>
        ) : (
          <></>
        )}
      </div>
      {viewDropdown && dropDownData.length > 0 ? (
        <div className="et-autocomplete-dropdown-backdrop">
          {dropDownData.map((item, index) => (
            <div
              key={index}
              className={`et-autocomplete-dropdown-listItem ${
                item.id
                  ? selectedItemIds.includes(item.id)
                    ? 'selected-listItem'
                    : ''
                  : item[valueKey] === inputValue ||
                      item[labelKey] === lastValue.current
                    ? 'selected-listItem'
                    : ''
              }`}
              onClick={() => handleClick(item)}>
              {isMultiSelect ? (
                <span className="et-autocomplete-dropdown-checkbox">
                  <div className="et-autocomplete-dropdown-checkbox-btn">
                    {multipleSelectedOptions.includes(item) ? (
                      <div className="et-autocomplete-dropdown-checkbox-active" />
                    ) : (
                      <></>
                    )}
                  </div>
                </span>
              ) : (
                <span className="et-autocomplete-dropdown-tickmark">
                  {/* {item[labelKey] === lastValue.current ? <>&#10003;</> : ' '} */}
                </span>
              )}
              <span>{item[labelKey]}</span>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default AutocompleteDropdownComponentRender;
